/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCatalogCategoryRequest
 */
export interface CreateCatalogCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCatalogCategoryRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCatalogCategoryRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCatalogCategoryRequest
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCatalogCategoryRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the CreateCatalogCategoryRequest interface.
 */
export function instanceOfCreateCatalogCategoryRequest(value: object): value is CreateCatalogCategoryRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function CreateCatalogCategoryRequestFromJSON(json: any): CreateCatalogCategoryRequest {
    return CreateCatalogCategoryRequestFromJSONTyped(json, false);
}

export function CreateCatalogCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCatalogCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'enabled': json['enabled'],
    };
}

export function CreateCatalogCategoryRequestToJSON(json: any): CreateCatalogCategoryRequest {
    return CreateCatalogCategoryRequestToJSONTyped(json, false);
}

export function CreateCatalogCategoryRequestToJSONTyped(value?: CreateCatalogCategoryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'enabled': value['enabled'],
    };
}

